import { useEffect, useRef, useState } from "react";
// @ts-ignore
import { H5P as H5PStandalone } from "h5p-standalone";
import { useTranslation } from "react-i18next";
import LoadingContainer from "@packages/components/Loading";

interface H5PTestProps {
  contentJsonPath: string;
}

type JsonValue = string | number | boolean | null | JsonObject | JsonValue[];
interface JsonObject {
  [key: string]: JsonValue;
}

const H5PTest = ({ contentJsonPath }: H5PTestProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [contentMap, setContentMap] = useState<
    { path: string; subContentId: string }[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  // TODO: @veyis: murat, bunu ben de materyal üretme esnasında üretip atabilirim buraya.
  const extractSubContentIds = (
    obj: JsonObject,
    currentPath: string[] = [],
  ): { path: string; subContentId: string }[] => {
    const result: { path: string; subContentId: string }[] = [];

    for (const key in obj) {
      const value = obj[key];

      // If the key is "subContentId", add it to the result
      if (key === "subContentId" && typeof value === "string") {
        result.push({ path: currentPath.join(" > "), subContentId: value });
      }

      // If the value is an object or array, recurse
      if (value && typeof value === "object") {
        const nestedPath = [...currentPath, key];
        result.push(...extractSubContentIds(value as JsonObject, nestedPath));
      }
    }

    return result;
  };

  const loadH5P = async () => {
    const el = containerRef.current;
    if (!el) return;

    // Download content JSON
    try {
      // console.log("contentJsonPath:", contentJsonPath);
      const response = await fetch(contentJsonPath + "/content.json");
      const result = await response.json();

      // Extract elements and create a Map
      const extractedMap = extractSubContentIds(result, ["root"]);
      setContentMap(extractedMap);

      console.log("Content Map:", extractedMap);
    } catch (error) {
      console.error("Error loading content JSON:", error);
      return;
    }

    const options = {
      h5pJsonPath: "/h5p/libraries",
      contentJsonPath,
      frameJs: "/frame.bundle.js",
      frameCss: "/h5p.css",
    };

    await new H5PStandalone(el, options);
    const userId = 63;
    H5P.externalDispatcher.on("xAPI", handleXAPIEvent);

    let filteredEvents: any[] = [];

    function handleXAPIEvent(event: any) {
      // console.log("handleXAPIEvent verb", event.data.statement.verb.id);
      // console.log("handleXAPIEvent RAW", event);
      if (isLoading) {
        setIsLoading(false);
      }
      const statement = event.data.statement;
      const verb = statement.verb.id;
      const subcontentId =
        statement.object.definition.extensions[
          "http://h5p.org/x-api/h5p-subContentId"
        ];
      const path = contentMap.find(
        (item) => item.subContentId === subcontentId,
      )?.path;
      statement.path = path;
      statement.subcontentId = subcontentId;
      statement.userId = userId;

      if (verb === "http://adlnet.gov/expapi/verbs/answered") {
        filteredEvents.push(statement);
      } else if (verb === "http://adlnet.gov/expapi/verbs/completed") {
        filteredEvents.push(statement);
        // sendToBackend();
        filteredEvents = [];
      } else {
        //console.log("not Filtered xAPI Event:", statement.verb.id);
      }
    }
  };

  useEffect(() => {
    const init = async () => {
      await loadH5P();
    };

    init();
  }, []);

  return (
    <div className="">
      {isLoading && (
        <div className={`flex flex-col justify-center items-center h-full`}>
          <LoadingContainer
            title={t("common.loading")}
            description={t("interactive_material.loadingDescription")}
            themeColor="blue"
            fullHeight={false}
          />
        </div>
      )}
      <div ref={containerRef}></div>
    </div>
  );
};

export default H5PTest;
